import { render } from "./CalculadoraCortes.vue?vue&type=template&id=07582a1d&scoped=true"
import script from "./CalculadoraCortes.vue?vue&type=script&lang=js"
export * from "./CalculadoraCortes.vue?vue&type=script&lang=js"

import "./CalculadoraCortes.vue?vue&type=style&index=0&id=07582a1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07582a1d"]])

export default __exports__